//NPM Packages
import React, { useState } from 'react';

const UseModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  function toggle() {
    setIsShowing(!isShowing);
  }
  return {
    isShowing,
    toggle
  };
};

export default UseModal;
